import React from 'react';
import {Container, Row, Col, Image} from 'react-bootstrap';


const Franchise = () => {
  return (
    <section className="sp-cnt-blk pongal png-border-btm franchise">  
        <div className="ban-franchising"></div>
      <Container>
        <div className="sp-cnt-in cul-pk text-center">   
            <div class="vertical-badge lft">
              <span>We Accept Digital Payments Only</span>
            </div>
                <div className="hdg">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/franchise-hdg.png`} fluid /></figure>
                </div>    
                <div className="pongal-time">
                    <div className="ltd-fd-bx">
                        <h3>Enquire Now</h3>
					</div>
                </div>
                <div className="mt-5 franchise container">
                    <form action="https://theroyalchitran.co.in/mail/submit.php" method="POST" className="">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="form-in">
                                    <input placeholder="Enter your Full Name" name="fullName" required="" type="text" id="formBasicName" className="form-control" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="form-in">
                                    <input placeholder="Enter your Email Address" name="email" required="" type="email" id="formBasicEmail" className="form-control" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="form-in">
                                    <input placeholder="Enter your Phone Number" name="phone" pattern="[0-9]{10}" required="" type="tel" id="formBasicPhone" className="form-control" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="form-in">
                                    <input placeholder="Preferred Franchise Location" name="franchiseLocation" required="" type="text" id="formBasicFranchiseLocation" className="form-control" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="form-in">
                                    <input placeholder="Enter your City" name="city" required="" type="text" id="formBasicCity" className="form-control" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="form-in">
                                    <input placeholder="Experience in Business/Franchising" name="experience" required="" type="text" id="formBasicExperience" className="form-control" />
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="form-in">
                                    <textarea rows="4" placeholder="Send Message" name="message" required="" id="formBasicTextarea" className="form-control"></textarea>
                                </div>
                            </div>
                            <button type="submit" className="w-100 sub btn btn-primary">Submit</button>
                        </div>
                    </form>
                </div>				
            </div>
        <div className='sp-cnt-in text-center'>
          <div className='sp-cnt-in2 no-package'>    
            <div class="vertical-badge rt">
              <span>We Accept Cashless  Payments Only</span>
            </div>
          <div className='hdg'><figure><Image src={`${process.env.PUBLIC_URL}/images/contact-us-hdg.png`} fluid  /></figure></div>
          <Row className='mb20 justify-content-left align-items-center cont-add row'>
            <Col lg={8}>
              <div className='map'>
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.38258398332!2d80.00340304683421!3d13.01129145468161!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a528d18036b98c3%3A0x1244bfd76aeeabd8!2sChokhi%20Dhani%20Chennai!5e0!3m2!1sen!2sin!4v1694518715177!5m2!1sen!2sin" width="100%" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
              </div>
            </Col>
            <Col lg={4}>
              <ul class="contact">
                  <li class="add">
                      <label>Address</label>
                      <p><b>The Royal Chitran</b>,
                          <br />NH-4, Near Queensland Theme Park, Kevlur Road Tandalam, Sriperumbudur, Chennai, Tamil Nadu 602105</p>
                  </li>
              </ul>
              <div class="btn-direction">
                  <a href="https://maps.app.goo.gl/YU6XZcUxq39hZkD67" target="_blank"><Image src={`${process.env.PUBLIC_URL}/images/ic-direction.png`} fluid />Direction</a>
              </div>
              <div class="contact-wrap small justify-start">
                  <div class="whatsapp-blk">
                      <div class="btn-whatsapp">
                          <a href="https://wa.me/9884334346" target="_blank"><Image src={`${process.env.PUBLIC_URL}/images/ic-whatsapp.png`} fluid />9884334346</a>
                      </div>
                  </div>
              </div>
            </Col>
          </Row> 
            
          <div className="key-information-bx">
              <h3>Key Information</h3>
              <Row>
                  <Col md={6}>
                      <div className="key-in">
                          <h4>TIMING:</h4>
                          <ul>
                              <li>We are open all 365 days from 4pm to 10pm</li>
                              <li>Dinner starts from 5.30 pm onwards</li>
                          </ul>
                      </div>
                  </Col>
                  <Col md={6}>
                      <div className="key-in even">
                          <h4>BOOKING AND PAYMENT</h4>
                          <ul>
                              <li>We are open all 365 days from 4pm to 10pm</li>
                              <li>Dinner starts from 5.30 pm onwards</li>
                          </ul>
                      </div>
                  </Col>
              </Row>
              <div className="btn-know-more"><a href="KeyInformation">Know More Info</a></div>
          </div>
        </div>
        </div>
        <div class="pongal-btm">
            <Row>
                <div class="col-sm-6">
                    <p>Booking are not required</p>
                    <p>No refund and transfer</p>
                    <p>Pure veg. Non Alcoholic &amp; Non Smoking Zone</p>
                </div>
                <div class="col-sm-6">
                    <div className='whatsapp-blk'>
                        <p>For more updates please</p>
                        <div className='btn-whatsapp'><a href='https://wa.me/9884334346' target='_blank'><Image src={`${process.env.PUBLIC_URL}/images/ic-whatsapp.png`} fluid /> 9884334346</a></div>
                    </div>
                </div>
            </Row>
        </div>
      </Container>
    </section>      
  )
}

export default Franchise